import { GetEventsQuery } from '@diritto/common/api/EventApi';
import { EventsResponseDto } from '@diritto/common/event/dtos/event.dto';
import { EventApi } from 'api/ApiHelper';
import { eventsQueryKey } from 'queries/events/queryKey';
import { useInfiniteQuery } from '@tanstack/react-query';

const EVENT_LIST_PAGE_ITEM_COUNT = 50;

const getNextPageParam = (lastGroup: EventsResponseDto, allGroups: EventsResponseDto[]) => {
  if (lastGroup.events.length < EVENT_LIST_PAGE_ITEM_COUNT) {
    return undefined;
  }
  return allGroups.reduce((acc, current) => acc + current.events.length, 0);
};

export const useGetEventsInfiniteQuery = (query: GetEventsQuery) =>
  useInfiniteQuery({
    queryKey: eventsQueryKey.eventList(query),
    queryFn: ({ pageParam = 0 }) =>
      EventApi.getEvents({
        offset: pageParam,
        limit: EVENT_LIST_PAGE_ITEM_COUNT,
        ...query,
      }),
    initialPageParam: 0,
    getNextPageParam,
  });
